import { render, staticRenderFns } from "./pbefore.vue?vue&type=template&id=d5f08f3a&scoped=true&"
import script from "./pbefore.vue?vue&type=script&lang=js&"
export * from "./pbefore.vue?vue&type=script&lang=js&"
import style0 from "./pbefore.vue?vue&type=style&index=0&id=d5f08f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f08f3a",
  null
  
)

export default component.exports